import { render, staticRenderFns } from "./TiktokLogoIcon.vue?vue&type=template&id=042968ef"
import script from "./TiktokLogoIcon.vue?vue&type=script&lang=js"
export * from "./TiktokLogoIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports